export const pathIncorrectEmail = (applicationID: string | undefined) => `/contractors/${applicationID ?? ''}/incorrect-email`